import { Outlet } from "react-router-dom";
import Box from "@mui/material/Box";
import SideBar from "./SideBar";
import { useSelector } from "react-redux";
import NoAccess from "../../NoAccess/NoAccess";

function HarborLayout() {
  const hasHarborAccess = useSelector(
    (state) => state.auth.metadata?.harbor?.access
  );

  return (
    <>
      {hasHarborAccess ? (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            flex: 1,
            overflow: "hidden",
            position: "relative",
          }}
        >
          {<SideBar />}
          <Box
            component="main"
            sx={{
              flex: 1,
              overflow: "auto",
              //   p: 3,
              bgcolor: "brain.background.default",
            }}
          >
            <Outlet />
          </Box>
        </Box>
      ) : (
        <NoAccess />
      )}
    </>
  );
}

export default HarborLayout;
